/* global axios */
import ApiClient from '../ApiClient';

// Assistentes de IA do FlexCalls (pra escolher quem faz a ligação na prospecção).
class FlexcallsAPI extends ApiClient {
  constructor() {
    super('flexcalls', { accountScoped: true });
  }

  assistants() {
    return axios.get(`${this.url}/assistants`);
  }

  // Catálogos do provider FlexCalls, pra tela do agente mostrar nome legível
  // em vez de um id cru (voiceId/languageId/llmModelId no nó de ligação).
  voices() {
    return axios.get(`${this.url}/voices`);
  }

  languages() {
    return axios.get(`${this.url}/languages`);
  }

  models() {
    return axios.get(`${this.url}/models`);
  }

  // Números do pool da Navi atribuídos a ESTA conta — é o que o nó oferece
  // como "número de saída". O id do fornecedor nunca chega aqui.
  numbers() {
    return axios.get(`${this.url}/numbers`);
  }
}

export default new FlexcallsAPI();
